import { useState } from 'react'
import { cn } from '@mriqbox/ui-kit'
import { avatarHue, initialsOf } from '@/lib/format'

export interface AvatarProps {
    nickname: string
    avatar?: string | null
    size?: number
    className?: string
}

export function Avatar({ nickname, avatar, size = 24, className }: AvatarProps) {
    /**
     * QUAL imagem falhou, e nao "falhou alguma vez".
     *
     * Com um booleano, a primeira falha condenava o componente: a pessoa
     * trocava por uma imagem boa e continuava aparecendo com as iniciais, sem
     * jeito de voltar atras a nao ser recarregando a pagina.
     */
    const [srcQueFalhou, setSrcQueFalhou] = useState<string | null>(null)
    const hue = avatarHue(nickname || '?')

    if (avatar && avatar !== srcQueFalhou) {
        return (
            <img
                src={avatar}
                alt={`Avatar de ${nickname}`}
                onError={() => setSrcQueFalhou(avatar)}
                className={cn('rounded-full object-cover shrink-0 select-none shadow-sm', className)}
                style={{
                    width: size,
                    height: size
                }}
            />
        )
    }

    return (
        <span
            className={cn('flex shrink-0 items-center justify-center rounded-full font-bold text-black select-none shadow-sm', className)}
            style={{
                width: size,
                height: size,
                fontSize: Math.max(9, Math.floor(size * 0.42)),
                backgroundColor: `hsl(${hue} 65% 62%)`
            }}
            aria-hidden
        >
            {initialsOf(nickname || '?')}
        </span>
    )
}
